import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from "rxjs";

import { EasyAuthService } from "../services/easyauth.service";
import { LoaderService } from "../../services/loader.service";

@Component({
  standalone: false,
  selector: "app-root",
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./app.component.html",
})
export class AppComponent {
  public readonly authReady$: Observable<boolean>;
  public readonly appBusy$: Observable<boolean>;

  constructor(
    private readonly easyAuth: EasyAuthService,
    private readonly loaderService: LoaderService,
  ) {
    // ✅ Auth bootstrap now happens via APP_INITIALIZER in AppBrowserModule
    // (do NOT call loadUser() here to avoid duplicate /api/me requests).
    this.authReady$ = this.easyAuth.isAuthReady();
    this.appBusy$ = this.loaderService.showLoader$;
  }
}
